import * as React from 'react';
import Desktop from './Desktop';
import Mobile from './Mobile';

export interface ComponentWrapperProps<ComponentPropsType> {
  type: React.ComponentType<ComponentPropsType>;
  mobileType?: React.ComponentType<ComponentPropsType>;
  desktopProps: ComponentPropsType;
  mobileProps: ComponentPropsType;
}

export default class ComponentWrapper<ComponentProps = {}> extends React.Component<
  ComponentWrapperProps<ComponentProps>
> {
  render() {
    const { type, desktopProps, mobileType, mobileProps } = this.props;
    return (
      <React.Fragment>
        <Desktop>{React.createElement(type, desktopProps)}</Desktop>
        <Mobile>{React.createElement(mobileType || type, mobileProps)}</Mobile>
      </React.Fragment>
    );
  }
}
